var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "live-footer" }, [
    _c("footer", { staticClass: "footer" }, [
      _vm.qrCodes.length
        ? _c(
            "div",
            { staticClass: "footer-qrimg" },
            _vm._l(_vm.qrCodes, function(qr, idx) {
              return _c(
                "div",
                { key: "qr_" + idx, staticClass: "qr-img-item" },
                [
                  _c("img", {
                    staticClass: "qr-img",
                    attrs: { src: qr.links }
                  }),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(qr.title))])
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.links.length
        ? _c(
            "div",
            { staticClass: "footer-links" },
            _vm._l(_vm.links, function(item, idx) {
              return _c("span", { key: "link_" + idx }, [
                _c("a", { attrs: { href: item.links, target: "_blank" } }, [
                  _vm._v(_vm._s(item.title))
                ]),
                _vm._v(" "),
                idx != _vm.links.length - 1
                  ? _c("span", { staticClass: "split" }, [_vm._v("|")])
                  : _vm._e()
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footer-text" }, [
      _c("span", [_vm._v("四川华晟联采供应链管理有限公司")]),
      _vm._v(" "),
      _c("span", [_vm._v("版权所有")]),
      _vm._v(" "),
      _c("span", [_vm._v("@www.likehuanxin.com | 400-8888-8794")]),
      _vm._v(" "),
      _c("span", [
        _vm._v("为了防范电信网络诈骗，如网民接到焕新生活官网电话，请立即接听。")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footer-text" }, [
      _c("span", [
        _c(
          "a",
          { attrs: { href: "https://beian.miit.gov.cn/", target: "_blank" } },
          [_vm._v("蜀ICP备2023017988号-1")]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-99df202c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99df202c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/live/LiveFooter.vue
// module id = null
// module chunks = 